<template>
    <div class="customer-list-element ordered" v-if="mode === 'sort-price'" :class="{filtered, selectable, selected}">
        <div class="select">
            <div class="icon"><img src="@/assets/check-mark-white.svg"/></div>
        </div>
        <div class="left">
            <div class="name">
                <span class="name-content" v-html="filteredName"></span>&nbsp;

                <span class="host-tag" v-if="customer.isHost">{{ $t('common.host') }}</span>
                <span class="dealer-tag" v-if="customer.isDealer">{{ $t('common.dealer') }}</span>

            </div>
            <div class="short-location">{{ shortLocation }}</div>
        </div>
        <div class="right">
            <div class="sales-volume">{{ formattedSalesVolume }}</div>
        </div>
    </div>

    <div class="customer-list-element-filtered" v-else-if="filtered.length > 0 && mode==='list'" :class="{selectable, selected}">
        <div class="select">
            <div class="icon"><img src="@/assets/check-mark-white.svg"/></div>
        </div>
        <div class="left">
            <div>
                <span class="name" v-html="filteredName"></span>
                &nbsp;
                <span class="host-tag" v-if="customer.isHost">{{ $t('common.host') }}</span>
                <span class="dealer-tag" v-if="customer.isDealer">{{ $t('common.dealer') }}</span>
            </div>
        </div>
        <div class="right">

            <div class="short-location">
                <template v-if="showSalesVolume">{{ formattedSalesVolume }}</template>
                <template v-else>{{ shortLocation }}</template>
            </div>
        </div>
    </div>

    <div class="customer-list-element" v-else :class="{selectable, selected}">
        <div class="select">
            <div class="icon"><img src="@/assets/check-mark-white.svg"/></div>
        </div>
        <div class="left">
            <div class="name">
                <span class="name-content">{{customer.firstName}} {{customer.lastName}}</span>
                <span class="host-tag" v-if="customer.isHost">{{ $t('common.host') }}</span>
                <span class="dealer-tag" v-if="customer.isDealer"> {{ $t('common.dealer') }}</span>
            </div>
            <div class="short-location">
                <template v-if="showSalesVolume">{{ formattedSalesVolume }}</template>
                <template v-else>{{ shortLocation }}</template>
            </div>
        </div>

        <div class="right" v-if="mode === 'list'">
            <div v-if="tempDeleted">
                <img src="@/assets/Mobile.svg" v-if="customer.mobile?.length > 0 ?? false">
                <img src="@/assets/NoMobile.svg" v-else>
            </div>
            <div v-if="tempDeleted">
                <img src="@/assets/Email.svg" v-if="customer.email?.length > 0 ?? false">
                <img src="@/assets/NoEmail.svg" v-else>
            </div>
            <div v-if="tempDeleted">
                <img  src="@/assets/ItemMenu.svg"/>
            </div>
        </div>

        <template v-if="mode === 'party' || mode === 'partyParticipants'">
            <Spinner v-if="participantIsBeingAdded" :size="60"/>
            <div class="right" v-else>
                <AddButton @click="actionButtonClicked" class="add-participant-button" :color="'green'" v-if="!partyHasParticipant" :text="$t('form.participant.addParticipantButton')" />
                <div :aria-disabled="true" onsubmit="false" class="button-primary-div button-primary__inverse button-primary__thin participant-added-button" v-else>{{ $t('form.participant.participantAddedButton') }}</div>
            </div>
        </template>

    </div>
</template>

<script>
 import Spinner from '@/components/core/Spinner.vue'
 import AddButton from "@/components/core/AddButton.vue";
 import {mapGetters} from "vuex";
 export default {
     name: "CustomerListElement",
     components: { AddButton, Spinner },
     props: {
         customer: { type: Object, required: true },
         // | id: -1,
         // | isHost: false,
         // | isVip: false,
         // | isCustomer: true,
         // | firstName: '',
         // | lastName: '',
         // | mobile: '',
         // | email: '',
         // | primaryAddress: {
         // |   addressLine1: '',
         // |   postCode: '',
         // |   postLocation: ''
         // | }
         filtered: { type: String, default: '' },
         party: null,
         showSalesVolume: Boolean,
         selectable: Boolean,
         selected: Boolean,
         mode: { type: String, default: 'list' } // list | party | partyParticipants | sort-price
     },
     emits: ['button-clicked'],
     computed: {
         ...mapGetters(['dealerLocale']),


         formattedSalesVolume(){

             // TODO: fix locale here
             return this.customer['sort-by-sale'].toLocaleString('nb-NB',{maximumFractionDigits:0})+".-"
         },
         shortLocation(){
             let postCode = this.customer.primaryAddress?.postCode ?? ''
             let postLocation = this.customer.primaryAddress?.postLocation ?? ''
             let shortLocation = `${postCode} ${postLocation}`
             return shortLocation.trim()
         },
         filteredName(){

             let ret='';

             let fName = this.customer?.firstName?.trim() ?? ""
             let spacer = " "
             let lName = this.customer?.lastName?.trim() ?? ""
             let name = fName.concat(spacer).concat(lName)


             if(this.filtered.length < 1) { return name }

             var pos = name.toLowerCase().indexOf(this.filtered.toLowerCase());
             ret = pos == -1 ? name :  name.substr(0, pos) + "<strong>"+this.filtered.toLowerCase()+"</strong>" +  name.substr(pos + this.filtered.length).toLowerCase();
             return ret.charAt(0).toUpperCase() + ret.substring(1);
         },
         filteredFirstName(){
             let ret='';
             if(!this.customer.firstName){ return '' }
             if(!this.filtered.length) { return this.customer.firstName }

             var pos = this.customer.firstName.toLowerCase().indexOf(this.filtered.toLowerCase());
             ret = pos == -1 ? this.customer.firstName :  this.customer.firstName.substr(0, pos) + "<strong>"+this.filtered.toLowerCase()+"</strong>" +  this.customer.firstName.substr(pos + this.filtered.length).toLowerCase();
             return '' + ret.charAt(0).toUpperCase() + ret.substring(1);
         },
         filteredLastName(){
             if(!this.customer.lastName){ return '' }
             if(!this.filtered.length) { return this.customer.lastName }

             var pos = this.customer.lastName.toLowerCase().indexOf(this.filtered.toLowerCase());
             return pos == -1 ? this.customer.lastName :  this.customer.lastName.substr(0, pos) + "<strong>"+this.filtered.toLowerCase()+"</strong>" +  this.customer.lastName.substr(pos + this.filtered.length).toLowerCase();
         },
         participantIsBeingAdded () {
             let customerId = this.customer.id
             if(this.$store.state.parties.addingParticipants[customerId]){
                 return true
             }
             return false
         },
         partyHasParticipant(){
             let customerId = this.customer?.id
             let participants = this.party?.customerOrders
             if(!customerId || !participants?.length){
                 return false
             }

             let found = false
             for(const customer of participants){
                 if(customerId == customer.customer.id){
                     found = true
                     break
                 }
             }

             return found
         },
         tempDeleted(){
             return false
         }
     },
     methods:{
         actionButtonClicked(){
             if(this.party === null){
                 return false;
             }
             this.$emit('button-clicked')
         }

     }
 }
</script>
